const commonActions = {
    SHOW_SIDEBAR: 'SHOW_SIDEBAR',
    SET_ALERT: 'SET_ALERT',
    SET_BUTTON_LOADER: 'SET_BUTTON_LOADER',
    SET_DRAFT_BUTTON_LOADER : 'SET_DRAFT_BUTTON_LOADER',
    SET_PAGE_LOADER: 'SET_PAGE_LOADER',
    SET_DASHBOARD_PAGE_LOADER: 'SET_DASHBOARD_PAGE_LOADER',
    SET_SHOW_MODAL: 'SET_SHOW_MODAL',
    SET_CLICKABLE: 'SET_CLICKABLE',
    SHOW_CLOSE_TAB_MODAL:"SHOW_CLOSE_TAB_MODAL",
    SHOW_CLOSE_EDITING_TAB_MODAL:"SHOW_CLOSE_EDITING_TAB_MODAL",
    SET_INLINE_ERRORS:"SET_INLINE_ERRORS",
    CLEAR_INLINE_ERRORS: "CLEAR_INLINE_ERRORS",
    SET_UPDATE_DETAILS:"SET_UPDATE_DETAILS",
    SHOW_PAYMENT_CONFIRMATION_MODAL:"SHOW_PAYMENT_CONFIRMATION_MODAL",
    USER_NAVIGATED_USING_BACK:"USER_NAVIGATED_USING_BACK",
    IS_VERIFY_OTP_MODAL_OPEN:"IS_VERIFY_OTP_MODAL_OPEN",
    SET_SHOW_REDIRECT_TO_HOME_MODAL:"SET_SHOW_REDIRECT_TO_HOME_MODAL"
};

export default commonActions;